<template>
    <app-layout title="Excel migratie">
        <template #header>
            <page-title title="Excel migratie" />
        </template>

        <template #pageContent>
            <Form @submitted="postForm" class="w-1/3">
                <Select
                    label="Type"
                    name="request_type_id"
                    :required="true"
                    :options="requestTypeOptions"
                    :sortByLabel="false"
                    v-model="form.request_type_id"
                    :error="form.errors.request_type_id"
                />
                <Input
                    type="file"
                    label="Excel"
                    name="excel"
                    v-model="form.excel"
                    :error="form.errors.excel"
                />
                <Button
                    buttonClass="Import"
                    text="Importeer excel"
                    type="submit"
                    class="self-end"
                    :loading="form.processing"
                />
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import {useForm} from "@inertiajs/inertia-vue3"
import {ref} from "vue";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Form,
        Input,
        Select,
    },
    props: [
        'requestTypes',
    ],
    setup (props){
        let requestTypeOptions = {}

        props.requestTypes.forEach(function(requestType) {
            requestTypeOptions[requestType.id] = requestType.type
        })

        const form = useForm({
            request_type_id: null,
            excel: null,
        })

        function postForm()
        {
            form.post(route('configuration.excel-migration.excel-import'))
        }

        return {
            state: store.state,
            ...store,
            form,
            postForm,
            requestTypeOptions,
        }
    },
}

</script>
